<template>
    <Modal :backdrop="backdrop" :visible="visible">
        <template #header>
            <div><h2 class="text-lg font-bold">Sei sicuro?</h2></div>
        </template>
        <template #main>
            <slot>
                <div>
                    Sei sicuro di procedere alla cancellazione del cliente?
                </div>
            </slot>
        </template>
        <template #footer>
            <div class="flex justify-end">
                <div class="flex justify-end pt-3">
                    <NextButton variant="outline-secondary"
                                @click="$emit('reject')"
                                class="col-start-3 py-2 px-4">
                        Chiudi
                    </NextButton>
                    <NextButton variant="primary"
                                @click="$emit('confirm')"
                                class="ml-4 py-2 px-4">
                        Sì
                    </NextButton>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'ConfermaModal',
    components: {
        NextButton,
        Modal
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        backdrop: {
            type: Boolean,
            default: false
        },
        titleText: {
            type: String,
            default: 'Sei sicuro?'
        },
        mainText: {
            type: String,
            default: 'Sei sicuro di procedere?'
        },
    }
})
export default class ConfermaModal extends Vue {
    visible!: boolean
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
